import React, { useState, useEffect } from "react";
import CloseIcon from "../../../assets/images/clear.svg";
import TextField from "@material-ui/core/TextField";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { useTranslation } from "react-i18next";
import { useStylesBoa } from "./style";
import InputLabel from "@material-ui/core/InputLabel";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import FormControl from "@material-ui/core/FormControl";
import { useComponentVisible } from "./outSideClick";
import { WalletMA, Amount } from "boa-sdk-ts";
import { BootstrapInput } from "./bootstrapInput";
import { amountFormat, getDuplicateFilter } from "../../../utils/WalletUtils";

const BoaAddSenderModal = (props) => {
  const { t } = useTranslation();
  const { senderList, remaining, addSenderHandler } = props;

  const classes = useStylesBoa();
  const [open, setOpen] = useState(false);

  const [totalBalance, setTotalBalance] = useState();
  const [spendableAbleBalance, setSpendableBalance] = useState();

  const [finalSuggestAddress, setFinalSuggestAddress] = useState([]);
  const [validateAllcase, setValidateAllcase] = useState(false);
  const [address, setAddress] = useState("");
  const [addressDropdown, setAddressDropdown] = useState(false);

  const [error, SetAddressError] = useState("");
  const [loader, setLoader] = useState(false);
  const [openConfirmModal, setConfirmModal] = useState(false);
  const [drawnAmount, setDrawnAmount] = useState();
  const { ref, isComponentVisible } = useComponentVisible(true);
  const { accounts } = WalletMA.instance();
  const [selectedAccount, setSelectedAccount] = useState();

  useEffect(() => {
    setAddress("");
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (!isComponentVisible) {
        setAddressDropdown(false);
      }
    });
  }, [isComponentVisible]);

  // Method to open add sender modal
  const addSenderModalOpenHandler = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirmAndDeniedModal = async (status) => {
    setConfirmModal(false);
    if (status) {
      setOpen(false);
      setAddress("");
      setSpendableBalance(0);
      setTotalBalance(0);
      setValidateAllcase(false);
      setLoader(false);
      setDrawnAmount("");
      setSelectedAccount(null);
    } else {
      setOpen(true);
    }
  };

  const SetError = (error) => {
    SetAddressError(error);
    setTimeout(() => {
      SetAddressError("");
    }, 3000);
  };

  // Click OK Button
  const confirmAdd = async () => {
    addSenderHandler(selectedAccount);
    setAddress("");
    setSpendableBalance(null);
    setTotalBalance(null);
    setValidateAllcase(false);
    setOpen(false);
    setDrawnAmount(null);
  };

  useEffect(() => {
    if (open) {
      setFinalSuggestAddress(
        getDuplicateFilter(
          accounts.items,
          senderList.map((a) => {
            return a.account;
          })
        )
      );
    }
  }, [open]);

  const onAddressDropdownClick = () => {
    if (addressDropdown) {
      setAddressDropdown(false);
    } else {
      setAddressDropdown(true);
    }
  };

  const selectAccountHandler = (account) => {
    setSelectedAccount(account);
    setAddressDropdown(false);
    setAddress(account.address.toString());
    setTotalBalance(account.balance.balance);
    setSpendableBalance(account.balance.spendable);
    const diff = Amount.greaterThan(remaining, account.balance.spendable);
    if (diff) {
      setDrawnAmount(account.balance.spendable);
    } else {
      setDrawnAmount(remaining);
    }
    setValidateAllcase(true);
  };

  return (
    // BOA Add Sender Modal Component
    <div className="SendBoxBoa">
      <div>
        <div className="sender_btn">
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openConfirmModal}
            onClose={(e) => confirmAndDeniedModal(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={openConfirmModal}>
              <div className={`${classes.paper} ${"modalBg"}`}>
                <img
                  alt="CloseIcon"
                  className="ClearModalImg"
                  src={CloseIcon}
                  onClick={() => confirmAndDeniedModal(false)}
                />
                <div className="modal-msg">
                  <p>{t("Changes_exist_Are_you_sure_you_want_to_cancel")}</p>
                </div>
                <div className="modal_footer">
                  <button
                    className="senderBtn"
                    onClick={() => confirmAndDeniedModal(true)}
                  >
                    {t("Yes")}
                  </button>
                  <button
                    className="cancel_btn"
                    onClick={() => confirmAndDeniedModal(false)}
                  >
                    {t("No")}
                  </button>
                </div>
              </div>
            </Fade>
          </Modal>
          <div className="boa_sender">
            <h3>{t("Sender")}</h3>
          </div>
          <div className="add_sender">
            <button
              className="btn btn-default senderBtn"
              disabled={props.senderBtnStatus}
              onClick={addSenderModalOpenHandler}
            >
              {t("Add_Sender")}
            </button>
            <div className="SendModal">
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={`${classes.paper} ${"modalBg"}`}>
                    <img
                      alt="CloseIcon"
                      className="ClearModalImg"
                      src={CloseIcon}
                      onClick={() => {
                        handleClose("", false);
                      }}
                    />
                    <h2 className="modalTitle" id="transition-modal-title">
                      {t("Add_Sender")}
                    </h2>
                    <div className="modalInput mb-40">
                      <div className="custom_select_container">
                        <div
                          ref={ref}
                          className="selected_address"
                          onClick={onAddressDropdownClick}
                        >
                          <FormControl fullWidth>
                            <InputLabel
                              shrink
                              htmlFor="demo-customized-textbox"
                            >
                              {t("Select_Account")}
                            </InputLabel>
                            <BootstrapInput
                              id="demo-customized-textbox"
                              disabled={true}
                              value={address}
                              autoComplete="off"
                              placeholder={finalSuggestAddress.length === 0 ? t("Select_Account_not_registered") : ""}
                              onChange={(e) => {
                                onChangeAddress(e.target.value);
                                setAddressDropdown(false);
                              }}
                              onBlur={(e) =>
                                addressDropdown
                                  ? ""
                                  : onfocusOutInputAddress(e.target.value)
                              }
                              fullWidth
                            />
                          </FormControl>
                          {addressDropdown ? (
                            <ArrowDropUpIcon className="caret" />
                          ) : (
                            <ArrowDropDownIcon className="caret" />
                          )}
                        </div>
                        {addressDropdown && (
                          <div className="options_list">
                            <ul>
                              {finalSuggestAddress.length > 0 &&
                                finalSuggestAddress.map((res, index) => (
                                  <li
                                    key={index}
                                    onClick={() => {
                                      selectAccountHandler(res);
                                    }}
                                  >
                                    {res.name}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="modal_balances">
                      <div className="item">
                        <p>{t("Balance")}:</p>
                        <p>
                          {amountFormat(totalBalance)}
                          {" BOA"}
                        </p>
                      </div>
                      <div className="item">
                        <p>{t("Spendable_Balance")}:</p>
                        <p>
                          {amountFormat(spendableAbleBalance)}
                          {" BOA"}
                        </p>
                      </div>
                    </div>
                    <div className="modalInput">
                      <TextField
                        label={t("Drawn_Amount")}
                        value={amountFormat(drawnAmount)}
                        disabled
                      />
                      <span className="boa">BOA</span>
                    </div>
                    <div className="useful-info">
                      <p>{t("Useful_Info_Line4")}</p>
                    </div>
                    <span className="validText">
                      <p style={{ color: "red" }}>{error}</p>
                      <span>
                        {loader ? (
                          <div className="noData1">
                            <div className="loader_container">
                              <div className="lds-ellipsis">
                                <div />
                                <div />
                                <div />
                                <div />
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </span>
                    </span>
                    <div className="modal_footer">
                      <button
                        className="btn btn-default senderBtn"
                        disabled={validateAllcase ? false : true}
                        onClick={() => confirmAdd()}
                      >
                        {t("Ok")}
                      </button>
                      <button
                        className="btn btn-default cancel_btn"
                        onClick={(e) => {
                          confirmAndDeniedModal(true);
                        }}
                      >
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </Fade>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoaAddSenderModal;
